import { Stack, Typography } from "@mui/material"

export function KeyValue({ label, value, mono }) {
    return (
        <Stack direction="row" spacing={2} alignItems="baseline">
            <Typography variant="caption" color="text.secondary" sx={{ minWidth: 60 }}>
                {label}
            </Typography>
            <Typography
                variant="body2"
                sx={{ fontFamily: mono ? "monospace" : undefined, fontSize: mono ? 12 : undefined }}
            >
                {value}
            </Typography>
        </Stack>
    )
}
